module.exports = __webpack_public_path__ + "media/images/icons/docspin-logo-icon-only-2372a96342007864c2fb00318f5fc2dc.svg";